/* Avenue Mon Plaisir — comportements des sections AMP */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };

  /* Barre d'annonce rotative */
  define('amp-rotator', class extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.amp-announce__msg')];
      if (this.items.length < 2 || reduceMotion) return;
      this.i = 0;
      const ms = (parseInt(this.dataset.speed, 10) || 4) * 1000;
      const tick = () => { this.items[this.i].classList.remove('is-active'); this.i = (this.i + 1) % this.items.length; this.items[this.i].classList.add('is-active'); };
      this.timer = setInterval(tick, ms);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => { clearInterval(this.timer); this.timer = setInterval(tick, ms); });
      this.addEventListener('focusin', () => clearInterval(this.timer));
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });

  /* Carrousel à défilement natif */
  define('amp-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.amp-slider__track');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track) return;
      const step = () => { const item = this.track.querySelector('.amp-slider__item'); return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth; };
      this.prev && this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      this.next && this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }));
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.classList.toggle('is-scrollable', max > 4);
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 4;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max - 4;
      };
      this.track.addEventListener('scroll', () => requestAnimationFrame(this.update), { passive: true });
      this.ro = new ResizeObserver(this.update); this.ro.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.ro && this.ro.disconnect(); }
  });

  /* Slideshow hero */
  define('amp-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.amp-hero__slide')];
      this.dots = [...this.querySelectorAll('.amp-hero__dot')];
      this.index = 0;
      if (this.slides.length < 2) return;
      this.querySelector('[data-prev]').addEventListener('click', () => { this.go(this.index - 1); this.stop(); });
      this.querySelector('[data-next]').addEventListener('click', () => { this.go(this.index + 1); this.stop(); });
      this.dots.forEach((d) => d.addEventListener('click', () => { this.go(+d.dataset.go); this.stop(); }));
      this.pauseBtn = this.querySelector('[data-pause]');
      this.pauseBtn && this.pauseBtn.addEventListener('click', () => (this.timer ? this.stop() : this.start()));
      if (this.dataset.autoplay === 'true' && !reduceMotion && !window.Shopify?.designMode) this.start();
      this.addEventListener('focusin', () => this.stop());
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.slides.findIndex((s) => s.contains(e.target) || s === e.target);
        if (i > -1) { this.stop(); this.go(i); }
      });
    }
    go(i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach((s, n) => { s.classList.toggle('is-active', n === this.index); s.toggleAttribute('inert', n !== this.index); });
      this.dots.forEach((d, n) => { d.classList.toggle('is-active', n === this.index); d.setAttribute('aria-current', n === this.index); });
    }
    start() { this.stop(); this.timer = setInterval(() => this.go(this.index + 1), (parseInt(this.dataset.speed, 10) || 6) * 1000); if (this.pauseBtn) { this.pauseBtn.textContent = '❚❚'; this.pauseBtn.setAttribute('aria-label', 'Mettre en pause le défilement'); } }
    stop() { clearInterval(this.timer); this.timer = null; if (this.pauseBtn) { this.pauseBtn.textContent = '►'; this.pauseBtn.setAttribute('aria-label', 'Reprendre le défilement'); } }
    disconnectedCallback() { clearInterval(this.timer); }
  });

  /* Onglets accessibles */
  define('amp-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
            this.select(n); this.tabs[n].focus();
          }
        });
      });
      document.addEventListener('shopify:block:select', (e) => {
        const i = this.tabs.findIndex((t) => document.getElementById(t.getAttribute('aria-controls')) === e.target);
        if (i > -1) this.select(i);
      });
    }
    select(i) {
      this.tabs.forEach((t, n) => {
        const on = n === i;
        t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
        document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
      });
    }
  });

  /* Vérification d'âge */
  define('amp-age-gate', class extends HTMLElement {
    connectedCallback() {
      const key = 'amp_age_ok';
      let ok = false;
      try { const v = localStorage.getItem(key); ok = v && Date.now() < +v; } catch (e) { ok = document.cookie.includes(key + '=1'); }
      if (ok) return this.remove();
      this.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const btn = this.querySelector('[data-age-accept]');
      btn && btn.focus();
      btn && btn.addEventListener('click', () => {
        const days = parseInt(this.dataset.days, 10) || 30;
        try { localStorage.setItem(key, String(Date.now() + days * 864e5)); } catch (e) { document.cookie = `${key}=1; max-age=${days * 86400}; path=/; SameSite=Lax`; }
        document.documentElement.style.overflow = '';
        this.remove();
      });
      this.addEventListener('keydown', (e) => { if (e.key === 'Tab') { const f = [...this.querySelectorAll('button, a')]; const first = f[0], last = f[f.length - 1]; if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); } } });
    }
  });

  /* Ajout rapide au panier : cartes produit, cadeaux débloqués, produits additionnels */
  const ampAddToCart = async (fd, host, trigger) => {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const onCartPage = !!document.getElementById('main-cart-items');
    if (!onCartPage && cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
      fd.append('sections_url', window.location.pathname);
      cart.setActiveElement && cart.setActiveElement(document.activeElement);
    }
    host.classList.add('is-loading');
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    host.querySelector('.amp-quick-add__error')?.remove();
    try {
      const res = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
      const data = await res.json();
      if (data.status) throw new Error(data.description || data.message);
      if (onCartPage) { window.location.reload(); return; }
      if (cart && typeof cart.renderContents === 'function' && data.sections) {
        cart.classList.contains('is-empty') && cart.classList.remove('is-empty');
        cart.renderContents(data);
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
      }
    } catch (err) {
      const p = document.createElement('p'); p.className = 'amp-quick-add__error'; p.setAttribute('role', 'alert');
      p.textContent = err.message || "Impossible d'ajouter ce produit.";
      host.appendChild(p);
    } finally {
      host.classList.remove('is-loading');
      if (trigger) trigger.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-amp-quick-add]');
    if (!form) return;
    e.preventDefault();
    ampAddToCart(new FormData(form), form, form.querySelector('button'));
  });

  window.ampUpdateCart = async (updates) => {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const onCartPage = !!document.getElementById('main-cart-items');
    const body = { updates };
    if (!onCartPage && cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    const res = await fetch((window.routes?.cart_update_url || '/cart/update') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
    });
    const data = await res.json();
    if (onCartPage) { window.location.reload(); return; }
    if (cart && typeof cart.renderContents === 'function' && data.sections) cart.renderContents(data);
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-amp-add]');
    if (!btn) return;
    e.preventDefault();
    const fd = new FormData();
    fd.append('id', btn.dataset.ampAdd);
    fd.append('quantity', '1');
    ampAddToCart(fd, btn.parentElement, btn);
  });
})();

/* Vidéo de fond avec bouton pause (accessibilité) */
(() => {
  if (customElements.get('amp-bg-video')) return;
  customElements.define('amp-bg-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.btn = this.querySelector('[data-toggle]');
      if (!this.video) return;
      this.video.muted = true; this.video.setAttribute('playsinline', ''); this.video.removeAttribute('controls');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { this.video.removeAttribute('autoplay'); this.video.pause(); this.sync(); }
      else { const p = this.video.play(); p && p.catch(() => this.sync()); }
      this.btn && this.btn.addEventListener('click', () => { this.video.paused ? this.video.play() : this.video.pause(); });
      this.video.addEventListener('play', () => this.sync());
      this.video.addEventListener('pause', () => this.sync());
    }
    sync() {
      const paused = this.video.paused;
      this.classList.toggle('amp-bg-video--paused', paused);
      this.btn && this.btn.setAttribute('aria-label', paused ? 'Lire la vidéo' : 'Mettre la vidéo en pause');
    }
  });
})();

/* FAQ à onglets + accordéon */
(() => {
  if (customElements.get('amp-faq')) return;
  customElements.define('amp-faq', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('.amp-faq__tab')];
      this.items = [...this.querySelectorAll('.amp-faq__item')];
      this.list = this.querySelector('.amp-faq__list');
      this.items.forEach((item) => {
        item.querySelector('.amp-faq__q').addEventListener('click', () => this.toggle(item));
      });
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(n); this.tabs[n].focus();
        });
      });
      document.addEventListener('shopify:block:select', (e) => {
        const item = this.items.find((it) => it === e.target || it.contains(e.target));
        if (!item) return;
        const i = this.tabs.findIndex((t) => t.dataset.cat === item.dataset.cat);
        if (i > -1) this.select(i);
        this.toggle(item, true);
      });
    }
    toggle(item, force) {
      const open = force !== undefined ? force : !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      item.querySelector('.amp-faq__q').setAttribute('aria-expanded', open);
    }
    select(i) {
      const cat = this.tabs[i].dataset.cat;
      this.tabs.forEach((t, n) => { const on = n === i; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
      this.list && this.list.setAttribute('aria-labelledby', this.tabs[i].id);
      this.items.forEach((item) => {
        const match = item.dataset.cat === cat;
        item.hidden = !match;
        if (!match) this.toggle(item, false);
      });
    }
  });
})();

/* Produits additionnels du panier : navigation par flèches */
(() => {
  if (customElements.get('amp-upsell')) return;
  customElements.define('amp-upsell', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.amp-upsell__track');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track) return;
      const step = () => {
        const item = this.track.querySelector('.amp-upsell__item');
        return item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth;
      };
      this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step() }));
      this.next.addEventListener('click', () => this.track.scrollBy({ left: step() }));
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.classList.toggle('is-scrollable', max > 4);
        this.prev.disabled = this.track.scrollLeft <= 4;
        this.next.disabled = this.track.scrollLeft >= max - 4;
      };
      this.track.addEventListener('scroll', () => requestAnimationFrame(this.update), { passive: true });
      this.ro = new ResizeObserver(this.update); this.ro.observe(this.track);
      requestAnimationFrame(this.update);
    }
    disconnectedCallback() { this.ro && this.ro.disconnect(); }
  });
})();

/* Cadeaux : retrait automatique quand le palier n'est plus atteint */
(() => {
  if (customElements.get('amp-rewards')) return;
  customElements.define('amp-rewards', class extends HTMLElement {
    connectedCallback() {
      const nodes = [...this.querySelectorAll('[data-amp-gift-key]')];
      if (!nodes.length || window.ampGiftSyncing) return;
      const updates = {};
      nodes.forEach((n) => { updates[n.dataset.ampGiftKey] = parseInt(n.dataset.ampGiftQty, 10) || 0; });
      window.ampGiftSyncing = true;
      Promise.resolve(window.ampUpdateCart && window.ampUpdateCart(updates))
        .catch(() => {})
        .finally(() => { window.setTimeout(() => { window.ampGiftSyncing = false; }, 800); });
    }
  });
})();

/* Méga-menu : ouverture au survol sur ordinateur */
(() => {
  const mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const setup = () => {
    const header = document.querySelector('.amp-header--hover-menu');
    if (!header || header.dataset.ampHoverReady === 'true') return;
    const items = header.querySelectorAll('.header__inline-menu > ul > li');
    if (!items.length) return;
    header.dataset.ampHoverReady = 'true';
    const closeAll = (except) => {
      items.forEach((li) => {
        const d = li.querySelector('details');
        if (d && d !== except && d.open) close(d);
      });
    };
    const open = (d) => {
      if (!mq.matches || d.open) return;
      closeAll(d);
      d.open = true;
      d.querySelector('summary')?.setAttribute('aria-expanded', 'true');
    };
    const close = (d) => {
      if (!d.open) return;
      d.open = false;
      d.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    };
    items.forEach((li) => {
      const details = li.querySelector('details');
      if (!details) return;
      let openTimer, closeTimer;
      li.addEventListener('mouseenter', () => {
        if (!mq.matches) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(() => open(details), 70);
      });
      li.addEventListener('mouseleave', () => {
        if (!mq.matches) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => close(details), 220);
      });
      li.addEventListener('click', () => { clearTimeout(openTimer); clearTimeout(closeTimer); });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
  };
  document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);
  document.addEventListener('shopify:section:load', () => { setup(); });
  setup();
})();